import { IMeetingChangeset } from '../abstract-meeting-changeset';
import { IControlMeetingDetailsDTO } from '../../../api/control.dao';
import { IOperatorDetailsDTO } from '../../../api/rooms.dao';
import { MeetingOperatorsEventBody, SyncOperatorDetails } from '../index';

export class OperatorsUpdatedInTheMeeting extends IMeetingChangeset<MeetingOperatorsEventBody> {
    public applyChangesToMeeting(meeting: Partial<IControlMeetingDetailsDTO>): Partial<IControlMeetingDetailsDTO> {
        this.updateOperatorsInMeeting(meeting);
        return meeting;
    }

    public getMeetingId(): number {
        return super.getChangeset().meetingId;
    }

    private updateOperatorsInMeeting(meeting: Partial<IControlMeetingDetailsDTO>): void {
        const { operators } = meeting;

        this.syncedOperators.forEach(syncedOperator => {
            const idx = this.getOperatorIndexById(syncedOperator.operatorId, operators);
            if (idx !== -1) {
                const operator = operators[idx];
                this.updateOperatorRole(syncedOperator, operator);
                this.updateOperatorStatus(syncedOperator, operator);
            }
        });
    }

    private get syncedOperators(): SyncOperatorDetails[] {
        return super.getChangeset().operators;
    }

    private getOperatorIndexById(id: number, operators: IOperatorDetailsDTO[]): number {
        return operators.findIndex(operator => operator.operatorId === id);
    }

    private updateOperatorRole(syncedOperator: SyncOperatorDetails, operator: IOperatorDetailsDTO): void {
        operator.operatorRole = syncedOperator.role || null;
    }
    private updateOperatorStatus(syncedOperator: SyncOperatorDetails, operator: IOperatorDetailsDTO): void {
        if (syncedOperator.status) {
            operator.operatorStatus = syncedOperator.status;
        }
    }
}
